export default __webpack_public_path__ + "static/vi-a6188062c8ca78e1bac3e29b3eee46bd.svg";